/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FusionMelcoModelsCustomWarning,
    FusionMelcoModelsCustomWarningFromJSON,
    FusionMelcoModelsCustomWarningFromJSONTyped,
    FusionMelcoModelsCustomWarningToJSON,
    FusionMelcoModelsPreview,
    FusionMelcoModelsPreviewFromJSON,
    FusionMelcoModelsPreviewFromJSONTyped,
    FusionMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface FusionMelcoModelsUserAlphabet
 */
export interface FusionMelcoModelsUserAlphabet {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    style?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    service_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    recommended_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    file_name: string;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    file_size: number;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    original_file_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    publish_state?: number;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    rfm_url?: string | null;
    /**
     * 
     * @type {Array<FusionMelcoModelsCustomWarning>}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    warning_list?: Array<FusionMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {Array<FusionMelcoModelsPreview>}
     * @memberof FusionMelcoModelsUserAlphabet
     */
    previews?: Array<FusionMelcoModelsPreview> | null;
}

export function FusionMelcoModelsUserAlphabetFromJSON(json: any): FusionMelcoModelsUserAlphabet {
    return FusionMelcoModelsUserAlphabetFromJSONTyped(json, false);
}

export function FusionMelcoModelsUserAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsUserAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'style': !exists(json, 'style') ? undefined : json['style'],
        'service_id': !exists(json, 'service_id') ? undefined : json['service_id'],
        'service_name': !exists(json, 'service_name') ? undefined : json['service_name'],
        'recommended_text': !exists(json, 'recommended_text') ? undefined : json['recommended_text'],
        'type': json['type'],
        'signature': json['signature'],
        'file_name': json['file_name'],
        'file_size': json['file_size'],
        'original_file_name': !exists(json, 'original_file_name') ? undefined : json['original_file_name'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'rfm_url': !exists(json, 'rfm_url') ? undefined : json['rfm_url'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(FusionMelcoModelsCustomWarningFromJSON)),
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(FusionMelcoModelsPreviewFromJSON)),
    };
}

export function FusionMelcoModelsUserAlphabetToJSON(value?: FusionMelcoModelsUserAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'style': value.style,
        'service_id': value.service_id,
        'service_name': value.service_name,
        'recommended_text': value.recommended_text,
        'type': value.type,
        'signature': value.signature,
        'file_name': value.file_name,
        'file_size': value.file_size,
        'original_file_name': value.original_file_name,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'publish_state': value.publish_state,
        'rfm_url': value.rfm_url,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(FusionMelcoModelsCustomWarningToJSON)),
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(FusionMelcoModelsPreviewToJSON)),
    };
}


